export default () => ({
  polygonPath: [],
  drawPolygonsState: false,
});
